import { render, staticRenderFns } from "./TeamLogo.vue?vue&type=template&id=37b60ec4&"
import script from "./TeamLogo.vue?vue&type=script&lang=js&"
export * from "./TeamLogo.vue?vue&type=script&lang=js&"
import style0 from "./TeamLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports